
import {getRolesPantalla} from '@/utils/funtionsGlobals';

export default [
  {
    path: '/MtoPermisosPantallaView',
    name: 'MtoPermisosPantallaView',
    component: () =>
      import('../views/configuracion/permisos-pantallas/PermisosPantallaView.vue'),
    meta: {
      title: 'Buscador de Pantallas',
      requiresAuthentication: true,
      requiresAuthorization: false,
      roles: getRolesPantalla('MtoPermisosPantallaView'),
      bread: {
        path: [
          'Configuración',
        ],
      },
    },
  },
];
